import * as React from "react";

import { EntityType, Division } from "../../../../models";
import { addNewRouteFor, editRouteFor, appNavigator } from "../../../routes";
import { Container } from "../../../Container";
import { Toolbar } from "../../Toolbar";
import { Button } from "../../../../components/Buttons";
import { EditCreateEntityActions } from "../../../actions/EditCreateEntityActions";
import { FlagStore } from "../../../flux/Flag";
import { ErrorStore } from "../../../flux/Error";
import { EditCreateEntityRoute, EditCreateEntityProps } from "../EditCreate/EditCreateEntityRoute";
import { EditCreateDivision } from "./EditCreateDivision";
import { EditCreateDivisionStore } from "./EditCreateDivisionStore";
import { EditCreateDivisionActions } from "./EditCreateDivisionActions";
import { ListStore } from "../../../flux/Grid/ListStore";
import { DivisionGrid } from "./DivisionGrid";
import { UpsertDivisionCommand, ShowCreateDivisionCommand, ShowEditDivisionCommand } from "./commands";
import { SearchProps } from "../SearchProps";
import { twoButtonDialogConfig } from "../../../utils/configure-store";
import { NoResults } from "../../Table/NoResults";
import { TableTitle } from "../../Table/TableTitle";
import { LabelStore } from "../../../flux/Label/LabelStore";
import { Polyglot } from "../../../../polyglot";
import { StickyMediator } from "../../../utils/StickyMediator";
import { GenericSearchWidget } from "../Search/GenericSearchWidget";
import { Command, Command1 } from "../../../../Command";

const appStyles = require('../../../app.scss');
const tableStyles = require('../../../../components/Table.scss');

interface Props
{
    polyglot: Polyglot;
    tableTitleStore: LabelStore;
    listStore: ListStore<Division>;

    editStore: EditCreateDivisionStore;
    divisionsLoadInProgress: FlagStore;
    upsertInProgressStore: FlagStore;
    upsertErrorStore: ErrorStore;
    upsertCommand: UpsertDivisionCommand;

    showCreateDivisionCommand: ShowCreateDivisionCommand;
    showEditDivisionCommand: ShowEditDivisionCommand;
    initUpsertCommand: Command;

    switchCommand: Command1<number>;
}

export class DivisionRoute extends React.Component<Props & SearchProps, any>
{
    private readonly stickyMediator = new StickyMediator();

    componentDidMount()
    {
        this.props.refresher.run();
    }

    render()
    {
        const entityType = EntityType.Division;
        const { polyglot } = this.props;

        const createForm = (props: Partial<EditCreateEntityProps>) => (
            <Container merge stores={twoButtonDialogConfig(this.props.upsertInProgressStore, this.props.upsertErrorStore)}>
                <EditCreateEntityRoute path={props.path}
                    title={props.title}
                    okTitle={props.okTitle}
                    cancelTitle={polyglot.t('button.cancel')}
                    renderEdit={() => (
                        <Container
                            merge stores={[
                                this.props.editStore,
                                [this.props.divisionsLoadInProgress, (store: FlagStore) => ({ loadingDivisions: store.isSet() })]
                            ]}
                            actions={new EditCreateDivisionActions()}
                            onMount={this.props.initUpsertCommand.execute}>
                                <EditCreateDivision polyglot={polyglot} loadingDivisions={false} draft={null} divisions={null} />
                        </Container>
                    )}
                    cancel={() => {
                        (new EditCreateEntityActions()).rejectDraft(entityType);
                        appNavigator.goToDivisionTab();
                    }}
                    ok={() => this.props.upsertCommand.execute(this.props.editStore.getState().draft)}
                />
            </Container>
        );
        
        return (
            <div>
                { createForm({title: polyglot.t('division.create_title'), okTitle: polyglot.t('button.create'), path: addNewRouteFor(entityType)})}
                { createForm({title: polyglot.t('division.edit_title'), okTitle: polyglot.t('button.save'), path: editRouteFor(entityType)})}
                <GenericSearchWidget {...this.props} />
                <div className={appStyles.StickyControlPanel} ref={this.stickyMediator.onToolbox}>
                    <TableTitle polyglot={polyglot} labelStore={this.props.tableTitleStore} />
                </div>
                <Container store={this.props.listStore}>
                    <DivisionGrid
                        className={tableStyles.StickyTable}
                        polyglot={polyglot}
                        items={null}
                        onEdit={(datum, row) => this.props.showEditDivisionCommand.execute(datum)}
                        switchTo={(datum, row) => this.props.switchCommand.execute((datum as Division).id)}
                        onThead={this.stickyMediator.onThead}
                    />
                </Container>
                <NoResults polyglot={polyglot} listStore={this.props.listStore} />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/Division/DivisionRoute.tsx